/**
 * @file http.js
 *
 * cf. https://www.w3.org/Protocols/rfc2616/rfc2616-sec10.html
 */

// 2xx - Successful
export const HTTP_OK = 200;

// 4xx - Client Error
export const HTTP_BAD_REQUEST = 400;
export const HTTP_NOT_FOUND = 404;
export const HTTP_UNPROCESSABLE_ENTITY = 422;

// 5xx - Server Error
export const HTTP_INTERNAL_SERVER_ERROR = 500;
export const HTTP_GATEWAY_TIMEOUT = 504;
export const HTTP_HTTP_VERSION_NOT_SUPPORTED = 505;

export const HTTP_STATUS_CODES = {
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Time-out",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Failed",
    413: "Request Entity Too Large",
    414: "Request-URI Too Large",
    415: "Unsupported Media Type",
    416: "Requested Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a teapot",
    422: "Unprocessable Entity",
    423: "Locked",
    424: "Failed Dependency",
    425: "Unordered Collection",
    426: "Upgrade Required",
    428: "Precondition Required",
    429: "Too Many Requests",
    431: "Request Header Fields Too Large",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Time-out",
    505: "HTTP Version not supported",
    506: "Variant Also Negotiates",
    507: "Insufficient Storage",
    509: "Bandwidth Limit Exceeded",
    510: "Not Extended",
    511: "Network Authentication Required",
};

const is5XX = (code) => {
    return (
        code >= HTTP_INTERNAL_SERVER_ERROR &&
        code <= HTTP_HTTP_VERSION_NOT_SUPPORTED
    );
};

const is4XX = (code) => {
    return code >= HTTP_BAD_REQUEST && code <= HTTP_UNPROCESSABLE_ENTITY;
};

export const isValidHttpErrorCode = (code) => {
    return is5XX(code) || is4XX(code);
};

export const httpErrorTitle = (code) => {
    if (code === HTTP_NOT_FOUND) {
        return "Sorry - we can't find that page";
    } else if (is5XX(code)) {
        return "Sorry - we have a problem";
    } else {
        return "Sorry - something went wrong";
    }
};

export const validErrorCodeOr404 = (code) => {
    return isValidHttpErrorCode(code) ? code : HTTP_NOT_FOUND;
};
